import React from 'react'

const Manual_opciones_ecommerce_1 = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Opciones de Ecommerce part. 1
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Conoce las principales opciones de configuración disponibles en el módulo de Ecommerce de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Opciones_de_Ecommerce_part_1__bGJ1u1VhQEWin74bvLhz7g?as=scrollable"
          className="scribe-iframe-general-76"
          width="100%"
          height="4800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_opciones_ecommerce_1
